// extracted by mini-css-extract-plugin
export default {"starInfo":"StarRating_starInfo__aOfLs","starGray":"StarRating_starGray__EFFj4"};